/** Türkçe sözlük · kabuk. Şekli bu dosya tanımlar; öteki diller ona bağlıdır. */
export const kabuk = {
  /** Sayfa adları (`lib/router.ts`). */
  sayfa: {
    "ana-sayfa": "Ana sayfa",
    hesaplar: "Hesaplar",
    hareketler: "Hareketler",
    "ice-aktar": "İçe aktar",
    pozisyonlar: "Pozisyonlar",
    rapor: "Varlık Dökümü",
    grafik: "Günlük Analiz",
    "donemsel-analiz": "Dönemsel Getiri",
    "sanal-hesaplar": "Sanal Hesaplar",
    izleme: "İzleme",
    fiyatlar: "Elle fiyat",
    degerleme: "Elle değerleme",
    ayarlar: "Ayarlar",
  },

  menu: {
    anaSayfa: "Ana sayfa",
    raporlar: "Raporlar",
    hesapIslemleri: "Hesap işlemleri",
    ayarlar: "Ayarlar",
    kisaAnaSayfa: "Ana sayfa",
    icerigeGec: "İçeriğe geç",
    anaGezinti: "Ana gezinti",
    tutarlariGizle: "Tutarları gizle",
    hizliGezinti: "Hızlı gezinti",
    asama: "Aşama 1 · yerel kayıt",
    sema: (v: number) => `şema v${v}`,
    kaliciDegil: "depolama kalıcı değil",
    kapat: "Kapat",
    menu: "Menü",
    sahteDepo: "Geliştirme modu: veriler bellekte tutulan SAHTE depoda. Sayfayı yenilediğinizde silinir.",
  },

  acilis: {
    vtAciliyor: "Yerel veritabanı açılıyor…",
    kasaAciliyor: "Kasa açılıyor…",
    tanitimaDon: "← Tanıtıma dön",
    baslatilamadi: "Parafon başlatılamadı",
    vtAcilamadi: "Yerel veritabanı açılamadı",
    dokunulmadi:
      "Verilere dokunulmadı. Sorun sürerse tarayıcının site verisini temizlemeden önce bir yedek alamayacağınızı unutmayın — bu durumda destek gerekir.",
    sayfayiYenile: "Sayfayı yenile",
  },

  merkez: {
    kosumdaYok: "Bu koşumda merkez bağlanmadı — arama ve izleme durumu devre dışı.",
    kosumdaOnbellekYok: "Bu koşumda cihaz fiyat önbelleği bağlanmadı.",
    ekrandaYok: "Merkez bu ekrana bağlanmadı — arama ve izleme durumu okunamıyor.",
    ekrandaOnbellekYok: "Bu ekrana cihaz fiyat önbelleği bağlanmadı.",
    kapatildi: "Merkez bu oturumda kapatıldı (?merkez=kapali). Arama ve eşitleme devre dışı.",
  },

  esitleme: {
    sebep: {
      acilis: "açılışta",
      "one-gelme": "sekme öne gelince",
      elle: "elle",
    },
    fiyat: (m: string) => `fiyat: ${m}`,
    onbellek: (m: string) => `önbellek: ${m}`,
    kur: (m: string) => `kur: ${m}`,
    kasa: (m: string) => `kasa: ${m}`,
  },

  hataSinir: {
    baslik: "Arayüz beklenmeyen bir hataya düştü",
    dokunulmadi: "Verilerinize dokunulmadı — bu hata yalnızca ekranı çizen katmanda oluştu.",
    teknikAyrinti: "Teknik ayrıntı",
    yenidenCiz: "Ekranı yeniden çiz",
    sayfayiYenile: "Sayfayı yenile",
  },

  sunucuYok: {
    dosyalar: "Parafon'un uygulama dosyaları sunucudan alınamadı, bu yüzden yerel veritabanı açılmadı.",
    yerinde:
      "Verileriniz bu cihazda, yerinde duruyor; hiçbirine dokunulmadı. Sunucu yeniden erişilebilir olunca aşağıdaki düğmeye basın.",
    yenidenDene: "Yeniden dene",
    temizlemeyinBaslik: "Tarayıcının site verisini temizlemeyin",
    temizlemeyin:
      "Kasa bu cihazın tarayıcı depolamasında tutulur. \"Site verisini temizle\" ya da \"Clear site data\" onu bu cihazdan siler; ancak bulut yedeğiniz varsa oradan geri gelir. Bu sorunu çözmez, çünkü sorun sunucuda.",
    teknikAyrinti: "Teknik ayrıntı",
  },

  baskaSekme: {
    baslik: "Parafon başka bir sekmede açık.",
    tekSekme:
      "Yerel veritabanı aynı anda yalnızca tek bir sekmede açılabilir. Şu anda başka bir sekme (ya da pencere) veritabanını tutuyor, bu yüzden bu sekme veriye erişemiyor.",
    guvende:
      "Verileriniz güvende ve bozulmadı. Yapılması gereken: Parafon'un açık olduğu diğer sekmeyi kapatın, sonra aşağıdaki düğmeye basın.",
    deneniyor: "Deneniyor…",
    yenidenDene: "Yeniden dene",
    sekmeyiKapat: "Bu sekmeyi kapat",
    nedenBaslik: "Neden böyle?",
    neden:
      "Veritabanı, tarayıcının OPFS depolamasında dosya kilidiyle çalışıyor. Bu kilit, iki sekmenin aynı dosyaya aynı anda yazıp veriyi bozmasını engelliyor. Sessizce bozuk çalışmak yerine açık bir hata vermesi bilinçli bir tercih.",
  },

  /** `lib/rpcError.ts` — hata kodunun ekrandaki metni. */
  hata: {
    LOCKED_BY_OTHER_TAB: "Parafon başka bir sekmede açık.",
    OPFS_UNAVAILABLE: "Bu tarayıcı yerel veritabanı depolamasını (OPFS) desteklemiyor.",
    MIGRATION_FAILED: "Veritabanı şema güncellemesi başarısız oldu. Veriye dokunulmadı.",
    NOT_FOUND: "Kayıt bulunamadı. Başka bir yerde silinmiş olabilir.",
    VALIDATION: "Girilen değerler kabul edilmedi.",
    TIMEOUT: "İstek zaman aşımına uğradı.",
    SERVER_UNAVAILABLE: "Sunucuya ulaşılamıyor.",
    KILITLI: "Kasa kilitli.",
    KURULUM_GEREKLI: "Bu cihazda kasa henüz kurulmamış.",
    DEFTER_KAYIP: "Şifreli kasa bu cihazda bulunamadı.",
    BASKA_DEFTER: "Bu yedek başka bir kasaya ait; bu cihazdaki kasayla birleştirilmez.",
    UNKNOWN: "Beklenmeyen bir hata oluştu.",
  },

  depo: {
    modulYuklenemedi: "cihaz veritabanı modülü yüklenemedi",
    donemselYok: "Bu derlemede Dönemsel Analiz yok.",
    sepetYok: "Bu derlemede sepet dağılımı yok.",
    getiriOzetiYok: "Bu derlemede getiri özeti yok.",
    yedektenKurYok: "Bu derlemede buluttan getirme yok; sayfayı yenileyin.",
    parolaDogrulaYok: "Bu derlemede parola doğrulanamıyor; sayfayı yenileyin.",
  },
};
